import { formatDate } from "@thenounproject/lingo-core";

export const formatInsightsDate = (date: string) => {
  // remove 00:00:00.000000+0000 from string
  const dateWithoutTime = date.split(" ")[0];
  return formatDate(dateWithoutTime, "MMM d, yyyy");
};
